import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class PurposeFilter extends React.Component {
  render () {
    const options = this.props.options.map(e => {
      const selected = !!this.props.selectedOptions.find(f => f.id === e.id);
      const classes = {
        btn: true,
        "btn-primary": selected,
        "btn-default": !selected
      };
      const option = <span key={`${e.id}-${selected}`} className={classNames(classes)} onClick={this.props.onChange(e, selected)}>
        <img src={e.buttonIconPath} /> {e.name}
      </span>;

      return option;
    });
    return (
      <div className="type-filter">
        <div><b>Filter by application:</b></div>
        <div className="filter-options">
          {options}
        </div>
      </div>
    );
  }
}


const purposeShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  buttonIconPath: PropTypes.string.isRequired
});

PurposeFilter.propTypes = {
  options: PropTypes.arrayOf(purposeShape).isRequired,
  selectedOptions: PropTypes.arrayOf(purposeShape),
  onChange: PropTypes.func.isRequired
};

export { purposeShape, PurposeFilter };
